/**
 * Genereert een stabiele, korte foutcode uit een willekeurige string-signature.
 *
 * Zelfde input → altijd dezelfde code. Bedoeld om in de error-toast een herkenbare,
 * consistente code te tonen per soort fout (bv. HTTP-status + URL-patroon), in plaats
 * van een wisselend fragment van het unieke Sentry event-id.
 *
 * Gebruikt de cyrb53 string-hash (goede spreiding, dependency-vrij) en encodeert het
 * resultaat naar een base36-code van 5 tekens.
 */
export function errorCode(signature: string): string {
  const hash = cyrb53(signature);
  return hash.toString(36).toUpperCase().padStart(5, "0").slice(-5);
}

function cyrb53(str: string, seed = 0): number {
  let h1 = 0xdeadbeef ^ seed;
  let h2 = 0x41c6ce57 ^ seed;
  for (let i = 0; i < str.length; i++) {
    const ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
